// extracted by mini-css-extract-plugin
module.exports = {"header":"styles_header__DUfSR","container":"styles_container__1fNgU","title":"styles_title__1dbUZ","wrapper":"styles_wrapper__1JQDq","answer":"styles_answer__34EFo"};